import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { startCase } from 'lodash-es';
import { TEditorType } from '@/helpers/editor';

@Component({})
export default class VisibilityDeleteComponentButton extends EditorBase {
  get componentType(): string {
    return startCase(this.selectedComponent.type);
  }

  get visibleHorizontally(): boolean {
    return this.selectedComponent?.hidden;
  }

  get visibleVertically(): boolean {
    return this.selectedComponent?.verticalSettings?.hidden;
  }

  onVisibilityClick(orientation: TEditorType) {
    this.toggleHide(this.selectedComponent, orientation);
  }

  onDeleteClick() {
    this.showSidebar = false;
    this.removeComponent();
  }
}
